import styled from '@emotion/styled'

// Chrome/Opera ignores autocomplete=“off”
// https://stackoverflow.com/a/22694173

export const HiddenInput = styled.input`
    opacity: 0;
    position: absolute;
`
